import React from 'react'
import { useSelector } from 'react-redux'
import { Redirect, Route, Switch, useLocation } from 'react-router-dom'
import Accounts from 'src/screens/accounts/Accounts'
import AdminRoute from 'src/screens/app/AdminRoute'
import DashboardWrapper from 'src/screens/app/DashboardWrapper'
import LoggedInRoute from 'src/screens/app/LoggedInRoute'
import VenueInternalWrapper from 'src/screens/app/VenueInternalWrapper'
import Catalogue from 'src/screens/catalogue/Catalogue'
import Invoice from 'src/screens/invoice/Invoice'
import Login from 'src/screens/login/Login'
import OrderChecklist from 'src/screens/order-checklist/OrderChecklist'
import Basket from 'src/screens/orders/basket/Basket'
import CheckoutScreen from 'src/screens/orders/checkout/CheckoutScreen'
import OrderSuccessScreen from 'src/screens/orders/checkout/OrderSuccessScreen'
import Credit from 'src/screens/orders/Credit'
import Invoices from 'src/screens/orders/Invoices'
import OrderedProducts from 'src/screens/orders/OrderedProducts'
import Orders from 'src/screens/orders/Orders'
import SpendOverTime from 'src/screens/orders/spend-over-time/SpendOverTime'
import Products from 'src/screens/products/Products'
import Register from 'src/screens/register/Register'
import ResetPassword from 'src/screens/reset-password/ResetPassword'
import Settings from 'src/screens/settings/Settings'
import Suppliers from 'src/screens/suppliers/Suppliers'
import IronWebCatalogues from 'src/screens/suppliers/IronWebCatalogues'
import VenueHome from 'src/screens/venue-home/VenueHome'
import VenueProducts from 'src/screens/venue-products/VenueProducts'
import VenueSuppliers from 'src/screens/venue-suppliers/VenueSuppliers'
import Venues from 'src/screens/venues/Venues'
import VenueGroups from 'src/screens/venue-groups/VenueGroups'
import VenueGroupCreate from 'src/screens/venue-groups/VenueGroupCreate'
import VenueGroupPage from 'src/screens/venue-groups/VenueGroupPage'
import AdminSupplierInvites from 'src/screens/admin-supplier-invites/AdminSupplierInvites'
import AdminOrders from '../admin-order/AdminOrders'
import AdminInvoiceExceptions from '../admin-invoice-exceptions/AdminInvoiceExceptions'
import TheBridge from 'src/screens/bridge/TheBridge'
import BridgeRoute from 'src/screens/app/BridgeRoute'
import {
  BRIDGE_ADMIN_LEGACY_SPARTACUS_PATH,
  BRIDGE_ADMIN_PATH,
} from 'src/utils/bridgeAdminNav'
import {
  BRIDGE_MINI_TAB_SPARTACUS,
  buildBridgeAdminPath,
} from 'src/constants/bridge'
import PastOrders from '../overview/PastOrders'
import PastOrdersSpending from '../past-orders-spending/PastOrdersSpending'
import Spending from '../spending/Spending'
import OverViewRoute from './OverviewRoute'
import Statement from '../orders/Statement'
import Stock from '../stock/Stock'
import Valuation from '../stock/Valuation'
import ReceiptingChecklist from '../receipting/ReceiptingChecklist'
import FullReceiptingHistory from '../receipting/FullReceiptingHistory'
import OrderApprovalScreen from '../order-approval/OrderApprovalScreen'
import CreditNotes from '../creditNotes/CreditsNotes'
import ProductIssues from '../productIssues/ProductIssues'
import AdminProductIssues from '../productIssues/AdminProductIssues'
import ValuationPDF from '../stock/ValuationPDF'
import InvoicesScreen from '../invoices/InvoicesScreen'
import InvoiceView from '../invoices/InvoiceView'
import DataplusScreen from '../dataplusIntegration/dataplusIntegration'
import EnableFunctionality from '../../components/EnableFunctionality'
import GrossProfit from '../orders/GrossProfit'
import SupplierdasbaordWrapper from './SupplierdasbaordWrapper'
import Customers from '../overview/customers/Customers'
import CustomerInvoices from '../overview/customerInvoices/CustomerInvoices'
import IncentiveScheme from '../overview/incentive-scheme/IncentiveScheme'
import Integration from '../overview/integration/Integration'
import Analytics from '../overview/analytics/Analytics'
import Marketing from '../overview/marketing/Marketing'
import Feedback from '../overview/feedback/Feedback'
import SupplierProductFiles from '../overview/product-files/SupplierProductFiles'
import DeleteDataPage from '../accounts/DeleteDataPage'
import RecipeDashboard from '../menu-builder/RecipeDashboard'
import Progress from '../progress/Progress'
import OMSCopilot from '../overview/copilot/OMSCopilot'
import EditOrderScreen from '../overview/copilot/EditOrderScreen'
import SpecialPurchases from '../special-purchases/SpecialPurchases'
import SpecialPurchaseOrderDetail from '../special-purchases/SpecialPurchaseOrderDetail'
import Approvals from '../approvals/Approvals'
import StockScreen from '../stock/StockScreen'
import WasteScreen from '../stock/WasteScreen'
import FoodSafetyHome from '../food-safety/FoodSafetyHome'
import FoodSafetySectionRoute from '../food-safety/FoodSafetySectionRoute'
import FoodSafetyReportsScreen from '../food-safety/FoodSafetyReportsScreen'
import FoodSafetySetupScreen from '../food-safety/FoodSafetySetupScreen'
import FoodSafetyDocumentsScreen from '../food-safety/FoodSafetyDocumentsScreen'
import FoodSafetyTrainingScreen from '../food-safety/FoodSafetyTrainingScreen'
import FoodSafetyVisitorsScreen from '../food-safety/FoodSafetyVisitorsScreen'
import XeroIntegration from '../integrations/xero/XeroIntegration'
import ReceiptingScreen from '../receipting/ReceiptingScreen'
import OMSPlans from '../subscriptions/OMSPlans'
import PaymentPage from '../subscriptions/PaymentPage'
import SubscriptionCheckoutResult from '../subscriptions/SubscriptionCheckoutResult'
import CustomerAllergenPage from '../menu-builder/components/CustomerAllergenPage'
import {
  canManageAnyVenue,
  hasBrandAdminAccess,
  hasOmsAdminAccess,
} from 'src/utils/adminAccess'

const Routes = () => {
  const venue = useSelector(state => state.venue.venue)
  const isVenueLoading = useSelector(state => state.venue.isLoading)
  const account = useSelector(state => state.auth.account)
  const isLoggedIn = useSelector(state => state.auth.isLoggedIn)
  const isAdmin = hasOmsAdminAccess(account)
  const supplierAdmin = account && account.supplierAdmin
  const isTFRAdmin = hasBrandAdminAccess(account)

  // fix bug with old email path
  const location = useLocation()
  const params = location.pathname.split('/')
  const emailVenueId = params[2]
  const emailSupplierId = params[3]
  const emailDate = params[4]

  const Redirector = () => (
    <Redirect to={`/v/${emailVenueId || venue?._id}/home`} />
  )

  return (
    <Switch>
      <Route
        exact
        path='/'
        component={() => (
          <Redirect
            to={
              isLoggedIn && supplierAdmin
                ? '/supplier'
                : isLoggedIn && !supplierAdmin
                ? '/venues'
                : 'login'
            }
          />
        )}
      />
      <Route exact path='/login' component={Login} />
      <Route exact path='/requestDeleteData' component={DeleteDataPage} />
      <Route exact path='/register' component={Register} />
      <Route exact path='/reset-password' component={ResetPassword} />
      <Route exact path='/allergen-grid' component={CustomerAllergenPage} />
      <Route
        exact
        path='/subscription-checkout-result'
        component={SubscriptionCheckoutResult}
      />
      <Route
        exact
        path='/checklist/:venueId/:supplierId/:date/:orderNumber'
        component={OrderChecklist}
      />
      <Route
        exact
        path='/receipting/checklist/:venueId/:supplierId/:PONumber'
        component={ReceiptingChecklist}
      />
      <Route
        exact
        path='/order-approval/:token'
        component={OrderApprovalScreen}
      />
      <Route
        exact
        path='/invoice/:venueId/:invoiceId/'
        component={InvoiceView}
      />
      {/* redirect from old email link to new with order number */}
      <Route
        exact
        path='/checklist/:venueId/:supplierId/:date'
        component={() => (
          <Redirect
            to={`/checklist/${emailVenueId}/${emailSupplierId}/${emailDate}/all`}
          />
        )}
      />
      <LoggedInRoute isLoggedIn={isLoggedIn}>
        {supplierAdmin ? (
          <Route path='/supplier'>
            {/*<AdminRoute supplierAdmin={supplierAdmin}>*/}
            <Route
              exact
              path='/supplier'
              component={() => <Redirect to='/supplier/orders' />}
            />
            <SupplierdasbaordWrapper
              supplierTitle={account?.supplier[0]?.title}
              location={location}
            >
              <Route
                exact
                path='/supplier/orders'
                component={AdminOrders}
              ></Route>
              {/*component={AdminOrders} />*/}
              <Route exact path='/supplier/spending' component={Spending} />
              <Route
                exact
                path='/supplier/products'
                component={SupplierProductFiles}
              />
              <Route exact path='/supplier/co-pilot' component={OMSCopilot} />
              <Route
                exact
                path='/supplier/co-pilot/:orderId/editOrder'
                component={EditOrderScreen}
              />
              <Route
                exact
                path='/supplier/customers'
                component={Customers}
              ></Route>
              <Route
                exact
                path='/supplier/customer-invoices'
                component={CustomerInvoices}
              ></Route>
              <Route
                exact
                path='/supplier/incentive-scheme'
                component={IncentiveScheme}
              ></Route>
              <Route
                exact
                path='/supplier/integration'
                component={Integration}
              ></Route>
              <Route
                exact
                path='/supplier/analytics'
                component={Analytics}
              ></Route>
              <Route
                exact
                path='/supplier/marketing'
                component={Marketing}
              ></Route>
              <Route
                exact
                path='/supplier/feedback'
                component={Feedback}
              ></Route>
              {/*</AdminRoute>*/}
            </SupplierdasbaordWrapper>
          </Route>
        ) : (
          <DashboardWrapper
            venue={venue}
            isAdmin={isAdmin}
            isTFRAdmin={isTFRAdmin}
            showGroups={canManageAnyVenue(account)}
          >
            <Route path='/admin'>
              <AdminRoute isAdmin={isAdmin}>
                <Route
                  exact
                  path='/admin'
                  component={() => <Redirect to='/admin/orders' />}
                />
                <Route exact path='/admin/orders' component={AdminOrders} />
                <Route exact path='/admin/spending' component={Spending} />
                <Route exact path='/admin/products' component={Products} />
                <Route exact path='/admin/suppliers' component={Suppliers} />
                <Route
                  exact
                  path='/admin/ironweb-catalogues'
                  component={IronWebCatalogues}
                />
                <Route
                  exact
                  path='/admin/supplier-invites'
                  component={AdminSupplierInvites}
                />
                <Route exact path='/admin/accounts' component={Accounts} />
                <Route
                  exact
                  path={BRIDGE_ADMIN_PATH}
                  render={() => (
                    <BridgeRoute account={account}>
                      <TheBridge />
                    </BridgeRoute>
                  )}
                />
                <Route
                  exact
                  path={BRIDGE_ADMIN_LEGACY_SPARTACUS_PATH}
                  render={() => (
                    <Redirect
                      to={buildBridgeAdminPath(BRIDGE_MINI_TAB_SPARTACUS)}
                    />
                  )}
                />
                <Route
                  exact
                  path='/admin/invoice-exceptions'
                  component={AdminInvoiceExceptions}
                />
                <Route
                  exact
                  path='/admin/product-issues'
                  component={AdminProductIssues}
                />
              </AdminRoute>
            </Route>

            <Route path='/overview'>
              <OverViewRoute>
                <Route
                  exact
                  path='/overview'
                  component={() => <Redirect to='/overview/pastOrders' />}
                />
                <Route
                  exact
                  path='/overview/pastOrders'
                  component={PastOrders}
                />
                <Route
                  exact
                  path='/overview/pastOrdersspending'
                  component={PastOrdersSpending}
                />
              </OverViewRoute>
            </Route>

            <Route exact path='/venues' component={Venues} />
            <Switch>
              <Route exact path='/venue-groups' component={VenueGroups} />
              <Route
                exact
                path='/venue-groups/new'
                component={VenueGroupCreate}
              />
              <Route
                exact
                path='/venue-groups/:groupId'
                component={VenueGroupPage}
              />
            </Switch>

            <VenueInternalWrapper
              venue={venue}
              isAdmin={isAdmin}
              loading={isVenueLoading}
            >
              <Route exact path='/v/:venueId' component={Redirector} />
              <Route exact path='/v/:venueId/home' component={VenueHome} />
              <Route path='/v/:venueId/purchasing'>
                <Orders>
                  <Route
                    exact
                    path='/v/:venueId/purchasing/orders'
                    component={Invoices}
                  />
                  <Route
                    exact
                    path='/v/:venueId/purchasing/gross-profit'
                    component={GrossProfit}
                  />
                  <Route
                    exact
                    path='/v/:venueId/purchasing/statement'
                    component={() => <Statement venueId={venue._id} />}
                  />
                  <Route
                    exact
                    path='/v/:venueId/purchasing/basket'
                    component={() => <Basket venueId={venue._id} />}
                  />
                  <Route
                    exact
                    path='/v/:venueId/purchasing/ordered'
                    component={OrderedProducts}
                  />
                  <Route
                    exact
                    path='/v/:venueId/purchasing/spendTime'
                    component={SpendOverTime}
                  />
                  <Route
                    exact
                    path='/v/:venueId/purchasing/invoices'
                    render={() => <InvoicesScreen venueId={venue._id} />}
                  />
                  <Route
                    exact
                    path='/v/:venueId/purchasing/dataplus'
                    render={() => {
                      if (venue.dataplusIntegration) {
                        return (
                          <DataplusScreen
                            venueId={venue._id}
                            venueTitle={venue.title}
                          />
                        )
                      }
                      return <EnableFunctionality />
                    }}
                  />
                  <Route
                    exact
                    path='/v/:venueId/purchasing/receipting'
                    render={() => <ReceiptingScreen />}
                  />
                  <Route
                    exact
                    path='/v/:venueId/purchasing/receipting/xero'
                    render={() => <XeroIntegration />}
                  />
                  <Route
                    exact
                    path='/v/:venueId/purchasing/creditnotes'
                    render={() => <CreditNotes venueId={venue._id} />}
                  />
                  <Route
                    exact
                    path='/v/:venueId/purchasing/resolvednotes'
                    render={({ match }) => (
                      <Redirect
                        to={`/v/${match.params.venueId}/purchasing/creditnotes?view=resolved`}
                      />
                    )}
                  />
                  <Route
                    exact
                    path='/v/:venueId/purchasing/product-issues'
                    render={() => <ProductIssues venueId={venue._id} />}
                  />

                  <Route
                    exact
                    path='/v/:venueId/purchasing/credit'
                    component={Credit}
                  />
                </Orders>
              </Route>
              <Route
                exact
                path='/v/:venueId/checkout'
                component={CheckoutScreen}
              />
              <Route
                exact
                path='/v/:venueId/checkout/success'
                component={OrderSuccessScreen}
              />
              <Route
                exact
                path='/v/:venueId/invoice/:date'
                component={Invoice}
              />
              <Route
                exact
                path='/v/:venueId/stockTakes/:stockTakeId'
                component={Stock}
              />
              <Route
                exact
                path='/v/:venueId/stockTakes/:stockTakeId/valuation-report'
                component={Valuation}
              />
              <Route
                exact
                path='/v/:venueId/stockTakes/:stockTakeId/wastage-report'
                component={Valuation}
              />
              <Route
                exact
                path='/v/:venueId/receipting/history'
                component={FullReceiptingHistory}
              />
              <Route
                exact
                path='/v/:venueId/stockTakes/:stockTakeId/wastage-report-pdf'
                component={ValuationPDF}
              />
              <Route
                exact
                path='/v/:venueId/stockTakes/:stockTakeId/valuation-report-pdf'
                component={ValuationPDF}
              />
              <Route
                exact
                path='/v/:venueId/invoice/:startDate/:endDate'
                component={Invoice}
              />
              <Route
                exact
                path='/v/:venueId/products'
                component={VenueProducts}
              />
              <Route exact path='/v/:venueId/catalogue' component={Catalogue} />
              <Route
                exact
                path='/v/:venueId/suppliers'
                component={VenueSuppliers}
              />
              <Route
                exact
                path='/v/:venueId/stock/wastage'
                component={WasteScreen}
              />
              <Route
                exact
                path='/v/:venueId/stockTakes'
                component={StockScreen}
              />
              <Route
                exact
                path='/v/:venueId/food-safety'
                component={FoodSafetyHome}
              />
              <Route
                exact
                path='/v/:venueId/food-safety/setup'
                component={FoodSafetySetupScreen}
              />
              <Route
                exact
                path='/v/:venueId/food-safety/reports'
                component={FoodSafetyReportsScreen}
              />
              <Route
                exact
                path='/v/:venueId/food-safety/documents'
                component={FoodSafetyDocumentsScreen}
              />
              <Route
                exact
                path='/v/:venueId/food-safety/training'
                component={FoodSafetyTrainingScreen}
              />
              <Route
                exact
                path='/v/:venueId/food-safety/visitors'
                component={FoodSafetyVisitorsScreen}
              />
              <Route
                exact
                path='/v/:venueId/food-safety/section/:section'
                component={FoodSafetySectionRoute}
              />
              <Route
                exact
                path='/v/:venueId/menu-builder'
                component={RecipeDashboard}
              />
              <Route exact path='/v/:venueId/progress' component={Progress} />
              <Route exact path='/v/:venueId/settings' component={Settings} />
              <Route
                exact
                path='/v/:venueId/subscriptions'
                render={({ match, location: loc }) => {
                  const params = new URLSearchParams(loc.search)
                  params.set('tab', 'subscriptions')
                  return (
                    <Redirect
                      to={`/v/${
                        match.params.venueId
                      }/settings?${params.toString()}`}
                    />
                  )
                }}
              />
              <Route
                exact
                path='/v/:venueId/subscriptions/checkout'
                component={PaymentPage}
              />
              <Route
                exact
                path='/v/:venueId/subscriptions/oms-plans'
                component={OMSPlans}
              />
              <Route
                exact
                path='/v/:venueId/integrations'
                render={({ match, location: loc }) => {
                  const params = new URLSearchParams(loc.search)
                  params.set('tab', 'integrations')
                  return (
                    <Redirect
                      to={`/v/${
                        match.params.venueId
                      }/settings?${params.toString()}`}
                    />
                  )
                }}
              />
              <Route
                exact
                path='/v/:venueId/special-purchases'
                component={SpecialPurchases}
              />
              <Route exact path='/v/:venueId/approvals' component={Approvals} />
              <Route
                exact
                path='/v/:requestId/special-purchase-order-detail'
                component={SpecialPurchaseOrderDetail}
              />
            </VenueInternalWrapper>
          </DashboardWrapper>
        )}
      </LoggedInRoute>
    </Switch>
  )
}

export default Routes
